import script from "./ShareableDownload.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareableDownload.vue?vue&type=script&setup=true&lang=js"

import "./ShareableDownload.vue?vue&type=style&index=0&id=40bb8932&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40bb8932"]])

export default __exports__